// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5dd52fb4","453":"97379c9e","455":"02c28d35","977":"fb775be3"}[chunkId] + ".chunk.js";
};